"use client";
import styled, { css, keyframes } from "styled-components";
import { Fonts, focusEffect, shadow } from "../../styles/globalsStyles";
import { defaultTheme } from "../../styles/defaultTheme";

const attentionAnimation = keyframes`
  0% {
    transform: scale(1);
}
    50% {
        transform: scale(1.1);

  }
  100% {

    transform: scale(1);
  }
`;
export const Button = styled.button<{ $ctaAnim?: boolean }>`
  background-color: white;
  border: 1px solid ${defaultTheme.secondaryColor};
  padding: 1rem 1.5rem;
  color: ${defaultTheme.primaryColor};
  ${shadow}
  transition: color 0.3s ease, background-color 0.3s ease, border-color 0.3s ease;
  ${Fonts.small};

  &:not(:disabled):hover {
    cursor: pointer;
    color: white;
    background-color: ${defaultTheme.secondaryColor};
    border: 1px solid white;
  }

  ${focusEffect}

  &:disabled {
    cursor: not-allowed;
    background-color: ${defaultTheme.tertiaryColor};
    opacity: 0.7;
  }

  ${(p) =>
    p.$ctaAnim &&
    css`
      animation: ${attentionAnimation} 2s linear infinite;
    `}
`;

export const BlackAssBtn = styled.button<{ $ctaAnim?: boolean }>`
  background-color: ${defaultTheme.primaryColor};
  border: 1px solid ${defaultTheme.secondaryColor};
  padding: 1rem 1.5rem;
  color: white;
  ${shadow}
  transition: color 0.3s ease, background-color 0.3s ease, border-color 0.3s ease;
  ${Fonts.small};

  &:not(:disabled):hover {
    cursor: pointer;
    color: white;
    background-color: ${defaultTheme.secondaryColor};
    border: 1px solid white;
  }

  ${focusEffect}

  &:disabled {
    cursor: not-allowed;
    background-color: ${defaultTheme.tertiaryColor};
    opacity: 0.7;
  }

  ${(p) =>
    p.$ctaAnim &&
    css`
      animation: ${attentionAnimation} 2s linear infinite;
    `}
`;
